import { Store } from 'libx'
import debounce from 'lodash/debounce'

export default class IntercomStore extends Store {
  constructor () {
    super(...arguments)
    this._dispatchUpdate = debounce(this._dispatchUpdate.bind(this), 1000)
  }

  /**
   * Batches up attributes and fires when we're done spamming.
   */
  update (attrs) {
    const authStore = this.rootStore.authStore
    if (authStore.user) {
      const data = {
        ...attrs,
        user_id: authStore.user.id,
        email: authStore.user.email,
        last_updated: new Date()
      }
      this._data = {
        ...this._data,
        ...data
      }
      this._dispatchUpdate()
    }
  }

  _dispatchUpdate () {
    window.Intercom('update', this._data)
    this._data = null
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ui/IntercomStore.js